import React, {Component} from 'react';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import EStatement from '../../Pages/EStatement';
import LoginScreen from '../../Pages/Login/Login';


const ToLogin = () => {
  return <Navigate to="/" replace={true} />;
};

const AuthNavigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginScreen />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/estatement/:modul/:id_so" element={<EStatement />} />
        <Route path="*" element={<ToLogin />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AuthNavigation;
